import i18n from 'i18n-js';

const t = (key, options) => i18n.t(`adminTenantGrid.${key}`, options);

// The backend writes 999999 as the shipment limit of every plan without one.
export const UNLIMITED_SHIPMENTS = 999999;

export const isUnlimited = max => Number(max) >= UNLIMITED_SHIPMENTS;

const INTERVAL_LABELS = {month: 'planPerMonth', year: 'planPerYear'};

const formatDollars = amount =>
  `$${amount.toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2
  })}`;

const STRIPE_OBJECT_ID = /^(si|price|plan|prod|sub)_/i;
const DATED_PLAN_PREFIX = /^\d{2} \d{2} \d{2} /;

export const cleanPlanName = plan => {
  if (typeof plan !== 'string') return null;
  const name = plan.trim().replace(DATED_PLAN_PREFIX, '');
  if (name === '' || STRIPE_OBJECT_ID.test(name)) return null;
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const formatPlan = ({amount, interval, plan}) => {
  const dollars = Number(amount);
  if (!Number.isFinite(dollars) || dollars <= 0) return cleanPlanName(plan);
  const price = formatDollars(dollars);
  const intervalLabel = INTERVAL_LABELS[interval];
  return intervalLabel ? t(intervalLabel, {amount: price}) : price;
};

export const parseDate = value => {
  if (typeof value !== 'string' || value === '') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Period rows roll at 00:00 UTC, so a local time zone would show the day before.
export const formatDate = value => {
  const date = parseDate(value);
  return date
    ? date.toLocaleDateString(i18n.locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
      })
    : null;
};

const WORKFLOW_LABELS = {
  default: 'workflowDefault',
  scan_to_cart: 'workflowScanToCart',
  product_first_scan_to_put_wall: 'workflowProductFirstPutWall',
  multi_put_wall: 'workflowMultiPutWall',
  pick_tote: 'workflowPickTote'
};

export const formatWorkflow = value => {
  if (typeof value !== 'string' || value === '') return null;
  return WORKFLOW_LABELS[value] ? t(WORKFLOW_LABELS[value]) : value;
};

export const currentPeriodText = data => {
  const start = formatDate(data.current_period_start);
  return start ? t('periodSince', {date: start}) : null;
};

export const lastPeriodText = data => {
  const from = formatDate(data.last_period_start);
  const to = formatDate(data.last_period_end);
  return from && to ? t('periodRange', {from, to}) : null;
};
